import { useEffect } from "react";

export default (functionToRun: () => void) => {
  useEffect(() => {
    functionToRun();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
